import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { converters } from '@ft-frontend/core';

import { changeLanguage } from 'reducers/redux/reduxSlice';

import { dynamicActivate } from 'utils/i18nLoaderHelper';

const LanguageSelector = ({
  visible,
  availableLocales,
  textColor = 'black',
}) => {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.redux.whitelabel.language);

  if (!visible) {
    return;
  }

  const handleChange = (event) => {
    dispatch(changeLanguage(event.target.value));
    dynamicActivate(event.target.value);
  };

  return (
    <Select
      color='secondary'
      sx={{
        color: textColor,
        width: '137px',
        fontSize: '1rem',
        '::before': {
          borderBottom: 'medium none white',
          content: 'none',
          transition: 'all 0s ease 0s',
        },
        '::after': {
          borderBottom: 'medium none white',
          transition: 'all 0s ease 0s',
        },
        '.MuiSelect-select': {
          paddingBottom: '0px',
        },
        '.MuiInput-input:focus': {
          backgroundColor: 'transparent',
        },
        '.MuiSelect-icon': {
          top: 'unset',
          color: textColor,
          height: '1rem',
          width: '1rem',
        },
      }}
      variant='standard'
      IconComponent={ExpandMoreIcon}
      value={language}
      onChange={handleChange}
    >
      {availableLocales?.map((locale) => (
        <MenuItem value={locale} key={locale}>
          {converters.getLanguageName(locale) || locale}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelector;
